/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Partly_CloudyInputs */

const en_ui_weather_partly_cloudy = /** @type {(inputs: Ui_Weather_Partly_CloudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partly cloudy`)
};

const de_ui_weather_partly_cloudy = /** @type {(inputs: Ui_Weather_Partly_CloudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilweise bewölkt`)
};

/**
* | output |
* | --- |
* | "Partly cloudy" |
*
* @param {Ui_Weather_Partly_CloudyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_partly_cloudy = /** @type {((inputs?: Ui_Weather_Partly_CloudyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Partly_CloudyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_partly_cloudy(inputs)
	return de_ui_weather_partly_cloudy(inputs)
});